// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kUEBf","right":"styles_right__17Fcu"};